import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './app/core/custom/custom-overlay-container';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthConfigModule } from './app/core/auth/auth-config.module';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { HubReducer, HubEffects } from './app/store';
import { accountReducer } from './app/accounts/store/accounts.reducer';
import { supportReducer, SupportEffects } from './app/support/store';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { reportsReducer } from './app/reports/store/reports.reducer';
import { provideRouter } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { AccountEffects } from './app/accounts/store/accounts.effects';
import { ReportsEffects } from './app/reports/store/reports.effects';
import { NewAccountEffects } from './app/new-accounts/store/new-accounts.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { newAccountReducer } from './app/new-accounts/store/new-accounts.index';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      AuthConfigModule,
      AppRoutingModule,
      FormsModule,
      StoreModule.forRoot({
        nessyHub: HubReducer,
        accounts: accountReducer,
        newAccounts: newAccountReducer,
        support: supportReducer,
        router: routerReducer,
        reports: reportsReducer
      }),
      EffectsModule.forRoot([HubEffects, AccountEffects, NewAccountEffects, SupportEffects, ReportsEffects]),
      ReactiveFormsModule,
      StoreDevtoolsModule.instrument({
        name: 'Nessy Hub'
      }),
      StoreRouterConnectingModule.forRoot()
    ),
    provideAnimationsAsync(),
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    provideAnimations(),
    provideRouter([])
  ]
}).catch((err) => console.error(err));
